import CEGuidelineCognitoLogin from './src/ui-web-components/LoginComponent/LoginComponent';
import CognitoService from "./src/Services/cognitoService";
import LoggerService from "./src/Services/loggerService";
import UserTokenManagementService from "./src/Services/userTokenManagementService";
import loginComponentRegister from "./src/ui-web-components/loginComponentRegister.js";
import resolveSafeRedirect from "./src/helpers/safeRedirect";

// Expose the CWE-601 redirect guard to the inline onLogin handler in index.html,
// which runs in global (non-module) scope and cannot import it directly.
if (typeof window !== 'undefined') {
    window.resolveSafeRedirect = resolveSafeRedirect;
}

export default {
    CEGuidelineCognitoLogin,
    CognitoService,
    UserTokenManagementService,
    LoggerService,
    loginComponentRegister
}